import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_2 = { class: "col-1 mt-3 mb-3" }
const _hoisted_3 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_6 = { class: "visually-hidden" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-12 text-center" }
const _hoisted_11 = { class: "col-12 text-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 1,
  class: "fontello-icon"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_17 = { class: "col" }

import { HomeUrlItem } from "../../models/Toolbar/HomeUrlItem";

import _ from "lodash";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useWidget } from "../../composables/useWidget";
import { useStore } from "../../models/Store/store";
import { useToolbar } from "@/composables/useToolbar";
import { useTenantConfig } from "@/composables/useTenantConfig";
import api from "@/services/TenantService";
import { TenantItem } from "@/models/Tenant/TenantItem";
import { TenantBookingConfiguration } from "@/models/Configuration/TenantBookingConfiguration";
import { useI18n } from "vue-i18n";
import { ParametersMadeModel } from "@/models/Step/ParametersMadeModel";
import { ExternalLoginBackUrlData } from "@/models/ExternalLogin/ExternalLoginBackUrlData";
import { UserLoggedData } from "@/models/Step/UserLoggedData";


export default /*#__PURE__*/_defineComponent({
  __name: 'TenantChoice',
  setup(__props) {

// eslint-disable-no-unused-vars
const route = useRoute();
const router = useRouter();
const { isTryAndBuyMode } = useWidget();
const store = useStore();
const toolbar = useToolbar();
const tenantConfig = useTenantConfig();
const { t } = useI18n();
const { redirectUrlData, userLoggedData } = useWidget();

const loadingTenant = ref(true);
const loadingNextPage = ref(false);
const tenants = ref<TenantItem[]>([]);

const tenantFromQuery = ref(false);
const tenantFromQueryByAlias = ref(false);
const serviceFromQuery = ref(false);
const serviceCmsFromQuery = ref(false);
const skipUserChoice = ref(false);

const newUrlToHome = ref<HomeUrlItem>({
    name: "tenant",
    query: {
        comune: "",
        tenant: "",
        tenantName: "",
        location: "",
        roomtype: "",
        service: "",
        servicecms: "",
        skipuserchoice: ""
    }
});

const getData = () => {
    loadingTenant.value = true;
    api.getTenants(store.tenantsFilter, tenantFromQueryByAlias.value)
        .then((res) => {
            store.tenants = res.data;
            tenants.value = res.data;
            const tnts = res.data;
            if (tnts && tnts.length == 1) {
                if (tnts[0].skipTenantPage || (tenantFromQuery.value && serviceFromQuery.value)) {
                    selectTenant(tnts[0]);
                }
            }
            //if (res.data.length == 0) {
            //self.refreshCallToKnowstate();
            //}
        })
        .catch((err) => {
            console.log(err);
            //self.refreshCallToKnowstate();
        })
        .finally(() => {
            loadingTenant.value = false;
        });
};

const getDataAndSelectTenant = (tenantSelected: number, callback: any) => {
    loadingTenant.value = true;
    api.getTenants(store.tenantsFilter, tenantFromQueryByAlias.value)
        .then((res) => {
            store.tenants = res.data;
            tenants.value = res.data;
            const tnts = res.data;
            if (tnts && tnts.length) {
                let tenantSelectedItem = tnts.find((item) => item.id == tenantSelected);
                if (tenantSelectedItem) {
                    selectTenantAndGetConfig(tenantSelectedItem, callback);
                }
                else if (tnts && tnts.length == 1) {
                    tenantSelectedItem = tnts[0];
                    selectTenantAndGetConfig(tenantSelectedItem, callback);
                }
            }
        })
        .catch((err) => {
            console.log(err);
            getData();
        })
        .finally(() => {
            loadingTenant.value = false;
        });
};

onMounted(() => {
    if (_.isEmpty(route.query) && isTryAndBuyMode.value) {
        const tenantUrl = window.location.hostname;
        console.log("tenantUrl: " + tenantUrl);
        const search = window.location.search;

        if (tenantUrl.includes("re-aprica-bergamo-frontend")) {
            router.replace({
                name: "tenant",
                query: { tenantName: "aprica", comune: "bergamo" }
            });
        }
        if (tenantUrl.includes("re-aprica-brescia-frontend")) {
            router.replace({
                name: "tenant",
                query: { tenantName: "aprica", comune: "brescia" }
            });
        }
        if (tenantUrl.includes("re-a2aci-frontend")) {
            router.replace({ name: "tenant", query: { tenantName: "aci" } });
        }
        if (tenantUrl.includes("re-a2acs-frontend")) {
            router.replace({ name: "tenant", query: { tenantName: "acs" } });
        }
        if (tenantUrl.includes("re-asvt-frontend")) {
            router.replace({ name: "tenant", query: { tenantName: "asvt" } });
        }
        if (tenantUrl.includes("cesf")) {
            router.replace({ name: "tenant", query: { tenantName: "training" } });
        }
        if (tenantUrl.includes("agid.c2i.it")) {
            router.replace({ name: "tenant", query: { tenantName: "training" } });
        }
        if (tenantUrl.includes("comuneagid.dp365.it")) {
            router.replace({ name: "tenant", query: { tenantName: "training" } });
        }
        if (tenantUrl.includes("comune-agid.dp365.it") || tenantUrl.includes("cortona-agid.dp365.it")) {
            if (search.includes("service=")) {
                var url = search.split("service=")[1];
                let servizioId = url.split("&")[0];
                router.replace({ name: "tenant", query: { tenantName: "training", service: servizioId } });
            } else {
                router.replace({ name: "tenant", query: { tenantName: "training" } });
            }
        }
    } else {
        if (userLoggedData.value) {
            try {
                let userDataJson = JSON.parse(userLoggedData.value) as UserLoggedData;
                if (userDataJson) {
                    store.userLoggedData = {
                        email: userDataJson.email,
                        firstName: userDataJson.firstName,
                        lastName: userDataJson.lastName,
                        taxCode: userDataJson.taxCode,
                        mobilePhone: userDataJson.mobilePhone
                    };
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        if (redirectUrlData.value && redirectUrlData.value.length) {
            let data = atob(decodeURIComponent(redirectUrlData.value));
            let backUrlData = JSON.parse(data) as ExternalLoginBackUrlData;

            store.stepsMade.day = backUrlData.stepsMade.day;
            store.stepsMade.details = backUrlData.stepsMade.details;
            store.stepsMade.interval = backUrlData.stepsMade.interval;
            store.stepsMade.location = backUrlData.stepsMade.location;
            store.stepsMade.month = backUrlData.stepsMade.month;
            store.stepsMade.municipality = backUrlData.stepsMade.municipality;
            store.stepsMade.service = backUrlData.stepsMade.service;
            store.stepsMade.spid = backUrlData.stepsMade.spid;

            let callback = function () {
                router.push({
                    name: "bookuserdata"
                });
            };

            getDataAndSelectTenant(backUrlData.tenantId, callback);

            return;
        }

        if (!_.isEmpty(route.query)) {
            //console.log("Route");
            //console.log(route);
            if (route.query.fturl == "editbook") {
                const queryTenants = route.query.tenant as string;

                store.tenantsFilter = [queryTenants];

                newUrlToHome.value.query.tenant = queryTenants;
                toolbar.updateHomeRoute(newUrlToHome.value);

                let callback = function () {
                    router.push({
                        name: "editbook",
                        query: route.query
                    });
                };

                getDataAndSelectTenant(route.query.tenant as any, callback);

                return;
            }

            if (route.query.comune) {
                const comune = route.query.comune as string;

                const comuniFromQuerySplitted = comune.split(",");
                if (comuniFromQuerySplitted && Array.isArray(comuniFromQuerySplitted) && comuniFromQuerySplitted.length > 1) {
                    store.municipalityFilter = comuniFromQuerySplitted;
                } else {
                    store.municipalityFilter = [comune];
                    store.stepsMade.municipality = comune;
                    store.proStepsMade.municipality = comune;
                }
                newUrlToHome.value.query.comune = route.query.comune as string;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }

            if (route.query.tenant) {
                tenantFromQuery.value = true;
                const queryTenants = route.query.tenant as string;
                const tenantsFromQuerySplitted = queryTenants.split(",");

                if (tenantsFromQuerySplitted && Array.isArray(tenantsFromQuerySplitted) && tenantsFromQuerySplitted.length > 1) {
                    store.tenantsFilter = tenantsFromQuerySplitted;
                } else {
                    store.tenantsFilter = [queryTenants];
                }
                newUrlToHome.value.query.tenant = queryTenants;
                toolbar.updateHomeRoute(newUrlToHome.value);
            } else if (route.query.tenantName) {
                tenantFromQuery.value = true;
                tenantFromQueryByAlias.value = true;
                const queryTenantsName = route.query.tenantName as string;
                const tenantsFromQuerySplitted = queryTenantsName.split(",");

                if (tenantsFromQuerySplitted && Array.isArray(tenantsFromQuerySplitted) && tenantsFromQuerySplitted.length > 1) {
                    store.tenantsFilter = tenantsFromQuerySplitted;
                } else {
                    store.tenantsFilter = [queryTenantsName];
                }
                newUrlToHome.value.query.tenantName = queryTenantsName;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }

            if (route.query.location) {
                const locId = route.query.location as string;
                store.totemLocation = locId;
                newUrlToHome.value.query.location = locId;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }

            if (route.query.roomtype) {
                const roomTypes = route.query.roomtype as string;
                const roomTypesFromQuerySplitted = roomTypes.split(",");

                if (roomTypesFromQuerySplitted && Array.isArray(roomTypesFromQuerySplitted) && roomTypesFromQuerySplitted.length > 1) {
                    store.roomTypeFilter = roomTypesFromQuerySplitted;
                } else {
                    store.roomTypeFilter = [roomTypes];
                }
                newUrlToHome.value.query.roomtype = roomTypes;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }

            if (route.query.service) {
                serviceFromQuery.value = true;
                newUrlToHome.value.query.service = route.query.service as string;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }
            if (route.query.servicecms) {
                serviceCmsFromQuery.value = true;
                newUrlToHome.value.query.servicecms = route.query.servicecms as string;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }
            if (route.query.skipuserchoice) {
                skipUserChoice.value = true;
                newUrlToHome.value.query.skipuserchoice = route.query.skipuserchoice as string;
                toolbar.updateHomeRoute(newUrlToHome.value);
            }
        }
    }
    getData();
});

const selectTenant = (tenant: TenantItem) => {
    store.tenantSelected = tenant;
    getConfiguration();
};

const selectTenantAndGetConfig = (tenant: TenantItem, callback: any) => {
    store.tenantSelected = tenant;
    getOnlyConfiguration(callback);
};

const getOnlyConfiguration = (callback: any) => {
    loadingNextPage.value = true;
    const queueEnabled = false;
    api.getConfigurations(store.tenantSelected.id, store.municipalityFilter, store.roomTypeFilter).then((res) => {
        if (callback) callback();
    });
};

const getConfiguration = () => {
    loadingNextPage.value = true;
    const queueEnabled = false;
    api.getConfigurations(store.tenantSelected.id, store.municipalityFilter, store.roomTypeFilter).then(() => {
        /* if (route.path.includes("totem")) {
        if (
          _.isNull(store.tenantConfig) === false &&
          _.isUndefined(store.tenantConfig) === false &&
          _.isNull(store.tenantConfig.configurations) === false &&
          _.isUndefined(store.tenantConfig.configurations) === false
        ) {
          var totemConfigs = Utils.getGenericConfig(
            store.tenantConfig.configurations.totem
          ) as TenantBookingConfiguration;
          queueEnabled = totemConfigs.bookingQueueenabled.value as boolean;
        }
        loadingNextPage.value = false;
      }
      if (queueEnabled) {
        store.pageAsGoToHome = "bookchoice";
        router.push({
          name: "bookchoice",
        });
      } else {*/
        if (serviceFromQuery.value || serviceCmsFromQuery.value) {
            //console.log("Servizio");
            //console.log(store.tenantConfig.bookingFlow);
            const bookingFlow = store.tenantConfig.bookingFlow;

            // Questo codice permette di andare direttamente alla scelta dello sportello, impostando il servizio
            /*
        const serviceNode = tenantConfig.findServiceById(bookingFlow[0], route.query.service as string);
        console.log(serviceNode);
        if (serviceNode) {
          store.stepsMade.service = serviceNode.item.service;
        }
        console.log(store.stepsMade.service);
        const locationRouteSelection = tenantConfig.getRouteNameLocationSelection();
        router.push({ name: locationRouteSelection, });
        */
            //

            // in data 05/05/2023, però, è stato chiesto di non atterrare sulla scelta dello sportello, ma su quella del servizio con informazioni precompilate
            // dal momento che un servizio può essere associato ad n percorsi (posso inserirlo come voglio nel bookingflow), prendo il primo percorso che trovo
            // e poi reindirizzo alla pagina bookservicechoice con id impostati
            let serviceNodeArray = "";
            if (serviceFromQuery.value) {
                serviceNodeArray = tenantConfig.findPathToServiceByServiceId(bookingFlow[0], route.query.service as string);
            } else {
                serviceNodeArray = tenantConfig.findPathToServiceByServiceCmsId(bookingFlow[0], route.query.servicecms as string);
            }

            if (serviceNodeArray) {
                router.push({ name: "bookservicechoice", params: { id: serviceNodeArray } });
            }
            //Se non ho trovato il servizio indicato, rimando alla pagina generica
            else {
                router.push({ name: "bookservice" });
            }
        } else if (skipUserChoice.value || tenantConfig.skipUserChoise.value) {
            router.push({ name: "bookservice" });
        } else {
            router.push({ name: "userchoice" });
        }
        //}
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (loadingNextPage.value || loadingTenant.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("common.loadingText")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_7, [
          (!loadingTenant.value && tenants.value.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.welcome")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h5", null, _toDisplayString(_unref(t)("titles.selectTenant")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenants.value, (tenant) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-12 col-md-6 col-xl-4 d-grid gap-2",
                      key: tenant.id
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-primary btn-lg my-3",
                        onClick: ($event: any) => (selectTenant(tenant))
                      }, [
                        _createElementVNode("div", null, [
                          (tenant.imageBase64)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: tenant.imageBase64,
                                alt: tenant.name,
                                class: "img-fluid",
                                style: {"max-height":"60px"}
                              }, null, 8, _hoisted_13))
                            : (_openBlock(), _createElementBlock("i", _hoisted_14, "")),
                          (!tenant.imageBase64)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(tenant.name), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_12)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h4", null, [
                    _createElementVNode("b", null, _toDisplayString(_unref(t)("messages.noReservationAllowed")), 1)
                  ])
                ])
              ]))
        ]))
  ]))
}
}

})